/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cdn.cnn.com/cnn//interactive/2024/01/us/quiz-us-primary-elections/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 39);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(5);

var _data = __webpack_require__(35);

var _utils = __webpack_require__(4);

var _Waypoint = __webpack_require__(38);

var _Waypoint2 = _interopRequireDefault(_Waypoint);

var _lazyload = __webpack_require__(3);

var _lazyload2 = _interopRequireDefault(_lazyload);

var _Tracker = __webpack_require__(2);

var _Tracker2 = _interopRequireDefault(_Tracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  Link media
__webpack_require__(37);
__webpack_require__(36);

//  Styles


// JSON


// JS


var pkgJson = __webpack_require__(34);
var bitlyFromPkg = pkgJson.bitlyUrl;
var slugFromPkg = pkgJson.slug;

var isMobileDevice = (0, _utils.mobileAndTabletCheck)();
var isMobile = window.innerWidth < 800 || isMobileDevice;

var tracker = new _Tracker2.default("" + slugFromPkg);

var HEADER_CAROUSEL_DELAY = 2500;

// DETECT SAFARI
if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
  //alert('It\'s Safari');
  var theHTML = document.querySelector("html");
  theHTML.classList.add("safari");
}

document.addEventListener("DOMContentLoaded", function () {
  $("._trigger-crossfade").hover(function () {
    $(this).parents("._hover-parent").addClass("hover");
  }, function () {
    $(this).parents("._hover-parent").removeClass("hover");
  });
});

//lazyload images
var lazyLoadInstance = new _lazyload2.default({
  elements_selector: "._lazy",
  callback_error: function callback_error() {
    console.log("error");
  }
});

/**
 * Project values
 * @desc: Values used to track progress through the quiz
 * 
 */

var shareText = void 0;
var selections = [];

/**
 * Method functions
 * @desc: Methods 
 * 
 */

// SOCIAL: opens social in new  window
function popupShare(url, title, w, h) {
  var left = screen.width / 2 - w / 2;
  var top = screen.height / 2 - h / 2;
  return window.open(url, title, "toolbar=no, menubar=no, scrollbars=yes, resizable=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
}

var getResult = function getResult() {
  return selections.filter(function (val) {
    return val == true;
  }).length;

  // const keys = {};

  // selections.forEach((p_key) =>
  // {
  //   keys[p_key] == undefined
  //     ? keys[p_key] = 1
  //     : keys[p_key] = keys[p_key] + 1;
  // });

  // return Object.keys(keys).map( p_key => ({ id: p_key, value: keys[p_key] }) ).sort((a, b) => a.value > b.value ? -1 : a.value < b.value ? 1 : 0 )[0];
};

var quizCompleted = function quizCompleted(e) {
  var score = getResult();
  var questions = [].slice.call(document.querySelectorAll('.questionBlock'));
  var resultObject = _data.results.score.filter(function (val) {
    return score >= parseInt(val.min);
  }).pop();
  var resultElement = document.getElementById('results');

  shareText = _data.results.shareText.replace('{$label}', score + " out of " + questions.length);

  document.getElementById('resultTitle').innerHTML = _data.results.title.replace('{$label}', score + " out of " + questions.length + " correct!");
  document.getElementById('resultLabel').innerHTML = resultObject.label;

  // document.getElementById('resultTitle').innerHTML = results.title.replace('{$label}', resultObject.label);
  // document.getElementById('resultDescription').innerHTML = resultObject.copy.map(({ value }) => value).join('');

  document.getElementById('resultsImage').src = resultObject.img && resultObject.img.value && resultObject.img.value.src || "";

  resultElement.classList.add('is-visible');

  // window.scrollTo({top: ((window.scrollY + resultElement.getBoundingClientRect().top) - 50 ), behavior: 'smooth'});


  //tracking quiz completions via Tracker
  tracker.trackMetric("quiz-complete-" + resultObject.id);

  //POST call to quiz metrics 
  var apiUrl = 'https://altystg077.execute-api.us-east-1.amazonaws.com/track';
  var quizScore = { "slug": slugFromPkg, "score": score };

  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(quizScore)
  }).then(function (response) {
    return response.json();
  }).then(function (quizScore) {
    console.log('Success!');
  }).catch(function (error) {
    console.error('Error:', error);
  });
};

// QUIZ: check for the correct answer + counter
var onOptionClicked = function onOptionClicked(e) {
  var selectionValue = e.currentTarget.attributes.value.value;

  var options = [].slice.call(e.currentTarget.parentElement.children);
  var correctElements = options.filter(function (el) {
    return el.attributes.value.value == 'true';
  });

  var questions = [].slice.call(document.querySelectorAll('.questionBlock'));
  var currentQuestion = questions[selections.length];
  var answerElement = currentQuestion.querySelector('.answerResponse');
  var answerResponseHeading = currentQuestion.querySelector('.answerResponseHeading');

  selections.push(selectionValue == 'true');

  // Set values
  answerResponseHeading.innerHTML = "" + (selectionValue && "Correct. " || "Incorrect. ");

  // Set styles
  if (!selectionValue) correctElements.forEach(function (el) {
    return el.classList.add('the-correct-answer');
  });
  e.currentTarget.classList.add(selectionValue && 'is-correct-answer' || 'is-wrong-answer');
  currentQuestion.classList.add(selectionValue && 'is-correct' || 'is-incorrect');
  options.forEach(function (element) {
    return element.classList.add('is-inactive');
  });
  answerElement.classList.add('is-visible');

  // Advance quiz

  var nextQuestionBlock = questions[selections.length];

  // If there's another question, proceed, otherwise process results.
  if (nextQuestionBlock) {
    nextQuestionBlock.classList.add('is-ready');
    // window.scrollTo({top: ((window.scrollY + nextQuestionBlock.getBoundingClientRect().top) - (( window.innerHeight - nextQuestionBlock.getBoundingClientRect().height ) / 2) ), behavior: 'smooth'});
  } else {
    quizCompleted();
  }
};

var initHeader = function initHeader() {
  var active = 0;
  var images = [].slice.call(document.querySelectorAll('header figure img.crossfade'));

  if (images.length > 0) {
    setInterval(function () {
      active = (active + 1) % images.length;
      images.forEach(function (el, idx) {
        return el.classList[active == idx ? 'add' : 'remove']('active');
      });
    }, HEADER_CAROUSEL_DELAY);

    images[0].classList.add('active');
  }
};

var initQuizQuestions = function initQuizQuestions() {

  // Initialize question logic.
  [].slice.call(document.querySelectorAll(".questionOption")).forEach(function (element) {
    return element.addEventListener("click", onOptionClicked);
  });

  // Facebook init
  document.getElementById("facebook").addEventListener('click', function (e) {
    var bitly = bitlyFromPkg;
    var url = "https://www.facebook.com/share.php?u=" + bitly + "&quote=" + shareText + " ";
    var title = "Facebook";
    var w = "500";
    var h = "439";

    popupShare(url, title, w, h);
  });

  // Twitter init
  document.getElementById("twitter").addEventListener('click', function (e) {
    var bitly = bitlyFromPkg;
    var title = "Twitter";
    var w = "500";
    var h = "439";
    var url = "https://www.twitter.com/share?text=" + shareText + "&url=" + bitly;

    popupShare(url, title, w, h);
  });
};

/**
 * Init commands
 * 
 */

initHeader();
initQuizQuestions();

// Waypoint recalculations
document.addEventListener("lazybeforeunveil", function (e) {
  _Waypoint2.default.refreshAll();
});

document.body.classList.add("start-app");
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(bitlyFromPkg, "bitlyFromPkg", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(slugFromPkg, "slugFromPkg", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(isMobileDevice, "isMobileDevice", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(isMobile, "isMobile", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(tracker, "tracker", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(HEADER_CAROUSEL_DELAY, "HEADER_CAROUSEL_DELAY", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(lazyLoadInstance, "lazyLoadInstance", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(shareText, "shareText", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(selections, "selections", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(popupShare, "popupShare", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(getResult, "getResult", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(quizCompleted, "quizCompleted", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(onOptionClicked, "onOptionClicked", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(initHeader, "initHeader", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");

  __REACT_HOT_LOADER__.register(initQuizQuestions, "initQuizQuestions", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/main.js");
}();

;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(32)


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tracker = function Tracker(project) {
	// project is unique for the specific project to be tracked
	this.project = project;
	this.tracked = {};
};

Tracker.prototype = {
	trackOnce: function trackOnce(data) {
		if (!data || this.tracked[data]) {
			return false;
		}

		this.tracked[data] = true;
		this.trackMetric(data);
	},

	trackMetric: function trackMetric(data) {
		try {
			window.trackMetrics({
				type: 'user-interaction',
				data: {
					interaction: 'interactive: ' + this.project + ' : ' + data
				}
			});
		} catch (e) {
			// JSMD library is missing
		}
	}
};

module.exports = Tracker;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Tracker, 'Tracker', '/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/proj/Tracker.js');
}();

;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }return _typeof(obj);
}

(function (global, factory) {
  ( false ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.LazyLoad = factory();
})(undefined, function () {
  'use strict';

  var runningOnBrowser = typeof window !== "undefined";
  var isBot = runningOnBrowser && !("onscroll" in window) || typeof navigator !== "undefined" && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent);
  var supportsIntersectionObserver = runningOnBrowser && "IntersectionObserver" in window;
  var supportsClassList = runningOnBrowser && "classList" in document.createElement("p");
  var defaultSettings = {
    elements_selector: "img",
    container: isBot || runningOnBrowser ? document : null,
    threshold: 300,
    thresholds: null,
    data_src: "src",
    data_srcset: "srcset",
    data_sizes: "sizes",
    data_bg: "bg",
    data_poster: "poster",
    class_loading: "loading",
    class_loaded: "loaded",
    class_error: "error",
    load_delay: 0,
    auto_unobserve: true,
    callback_enter: null,
    callback_exit: null,
    callback_reveal: null,
    callback_loaded: null,
    callback_error: null,
    callback_finish: null,
    use_native: false
  };

  var getInstanceSettings = function getInstanceSettings(customSettings) {
    return _extends({}, defaultSettings, customSettings);
  };
  /* Creates instance and notifies it through the window element */

  var createInstance = function createInstance(classObj, options) {
    var event;
    var eventString = "LazyLoad::Initialized";
    var instance = new classObj(options);

    try {
      // Works in modern browsers
      event = new CustomEvent(eventString, {
        detail: {
          instance: instance
        }
      });
    } catch (err) {
      // Works in Internet Explorer (all versions)
      event = document.createEvent("CustomEvent");
      event.initCustomEvent(eventString, false, false, {
        instance: instance
      });
    }

    window.dispatchEvent(event);
  };
  /* Auto initialization of one or more instances of lazyload, depending on the 
      options passed in (plain object or an array) */

  function autoInitialize(classObj, options) {
    if (!options) {
      return;
    }

    if (!options.length) {
      // Plain object
      createInstance(classObj, options);
    } else {
      // Array of objects
      for (var i = 0, optionsItem; optionsItem = options[i]; i += 1) {
        createInstance(classObj, optionsItem);
      }
    }
  }

  var dataPrefix = "data-";
  var processedDataName = "was-processed";
  var timeoutDataName = "ll-timeout";
  var trueString = "true";

  var getData = function getData(element, attribute) {
    return element.getAttribute(dataPrefix + attribute);
  };

  var setData = function setData(element, attribute, value) {
    var attrName = dataPrefix + attribute;

    if (value === null) {
      element.removeAttribute(attrName);
      return;
    }

    element.setAttribute(attrName, value);
  };

  var resetWasProcessedData = function resetWasProcessedData(element) {
    return setData(element, processedDataName, null);
  };

  var setWasProcessedData = function setWasProcessedData(element) {
    return setData(element, processedDataName, trueString);
  };

  var getWasProcessedData = function getWasProcessedData(element) {
    return getData(element, processedDataName) === trueString;
  };

  var setTimeoutData = function setTimeoutData(element, value) {
    return setData(element, timeoutDataName, value);
  };

  var getTimeoutData = function getTimeoutData(element) {
    return getData(element, timeoutDataName);
  };

  var purgeProcessedElements = function purgeProcessedElements(elements) {
    return elements.filter(function (element) {
      return !getWasProcessedData(element);
    });
  };

  var purgeOneElement = function purgeOneElement(elements, elementToPurge) {
    return elements.filter(function (element) {
      return element !== elementToPurge;
    });
  };

  var safeCallback = function safeCallback(callback, arg1, arg2, arg3) {
    if (!callback) {
      return;
    }

    if (arg3 !== undefined) {
      callback(arg1, arg2, arg3);
      return;
    }

    if (arg2 !== undefined) {
      callback(arg1, arg2);
      return;
    }

    callback(arg1);
  };

  var updateLoadingCount = function updateLoadingCount(instance, plusMinus) {
    instance._loadingCount += plusMinus;

    if (instance._elements.length === 0 && instance._loadingCount === 0) {
      safeCallback(instance._settings.callback_finish, instance);
    }
  };

  var getSourceTags = function getSourceTags(parentTag) {
    var sourceTags = [];

    for (var i = 0, childTag; childTag = parentTag.children[i]; i += 1) {
      if (childTag.tagName === "SOURCE") {
        sourceTags.push(childTag);
      }
    }

    return sourceTags;
  };

  var setAttributeIfValue = function setAttributeIfValue(element, attrName, value) {
    if (!value) {
      return;
    }

    element.setAttribute(attrName, value);
  };

  var setImageAttributes = function setImageAttributes(element, settings) {
    setAttributeIfValue(element, "sizes", getData(element, settings.data_sizes));
    setAttributeIfValue(element, "srcset", getData(element, settings.data_srcset));
    setAttributeIfValue(element, "src", getData(element, settings.data_src));
  };

  var setSourcesImg = function setSourcesImg(element, settings) {
    var parent = element.parentNode;

    if (parent && parent.tagName === "PICTURE") {
      var sourceTags = getSourceTags(parent);
      sourceTags.forEach(function (sourceTag) {
        setImageAttributes(sourceTag, settings);
      });
    }

    setImageAttributes(element, settings);
  };

  var setSourcesIframe = function setSourcesIframe(element, settings) {
    setAttributeIfValue(element, "src", getData(element, settings.data_src));
  };

  var setSourcesVideo = function setSourcesVideo(element, settings) {
    var sourceTags = getSourceTags(element);
    sourceTags.forEach(function (sourceTag) {
      setAttributeIfValue(sourceTag, "src", getData(sourceTag, settings.data_src));
    });
    setAttributeIfValue(element, "poster", getData(element, settings.data_poster));
    setAttributeIfValue(element, "src", getData(element, settings.data_src));
    element.load();
  };

  var setSourcesBgImage = function setSourcesBgImage(element, settings) {
    var srcDataValue = getData(element, settings.data_src);
    var bgDataValue = getData(element, settings.data_bg);

    if (srcDataValue) {
      element.style.backgroundImage = "url(\"".concat(srcDataValue, "\")");
    }

    if (bgDataValue) {
      element.style.backgroundImage = bgDataValue;
    }
  };

  var setSourcesFunctions = {
    IMG: setSourcesImg,
    IFRAME: setSourcesIframe,
    VIDEO: setSourcesVideo
  };

  var setSources = function setSources(element, instance) {
    var settings = instance._settings;
    var tagName = element.tagName;
    var setSourcesFunction = setSourcesFunctions[tagName];

    if (setSourcesFunction) {
      setSourcesFunction(element, settings);
      updateLoadingCount(instance, 1);
      instance._elements = purgeOneElement(instance._elements, element);
      return;
    }

    setSourcesBgImage(element, settings);
  };

  var addClass = function addClass(element, className) {
    if (supportsClassList) {
      element.classList.add(className);
      return;
    }

    element.className += (element.className ? " " : "") + className;
  };

  var removeClass = function removeClass(element, className) {
    if (supportsClassList) {
      element.classList.remove(className);
      return;
    }

    element.className = element.className.replace(new RegExp("(^|\\s+)" + className + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "");
  };

  var genericLoadEventName = "load";
  var mediaLoadEventName = "loadeddata";
  var errorEventName = "error";

  var addEventListener = function addEventListener(element, eventName, handler) {
    element.addEventListener(eventName, handler);
  };

  var removeEventListener = function removeEventListener(element, eventName, handler) {
    element.removeEventListener(eventName, handler);
  };

  var addEventListeners = function addEventListeners(element, loadHandler, errorHandler) {
    addEventListener(element, genericLoadEventName, loadHandler);
    addEventListener(element, mediaLoadEventName, loadHandler);
    addEventListener(element, errorEventName, errorHandler);
  };

  var removeEventListeners = function removeEventListeners(element, loadHandler, errorHandler) {
    removeEventListener(element, genericLoadEventName, loadHandler);
    removeEventListener(element, mediaLoadEventName, loadHandler);
    removeEventListener(element, errorEventName, errorHandler);
  };

  var eventHandler = function eventHandler(event, success, instance) {
    var settings = instance._settings;
    var className = success ? settings.class_loaded : settings.class_error;
    var callback = success ? settings.callback_loaded : settings.callback_error;
    var element = event.target;
    removeClass(element, settings.class_loading);
    addClass(element, className);
    safeCallback(callback, element, instance);
    updateLoadingCount(instance, -1);
  };

  var addOneShotEventListeners = function addOneShotEventListeners(element, instance) {
    var loadHandler = function loadHandler(event) {
      eventHandler(event, true, instance);
      removeEventListeners(element, loadHandler, errorHandler);
    };

    var errorHandler = function errorHandler(event) {
      eventHandler(event, false, instance);
      removeEventListeners(element, loadHandler, errorHandler);
    };

    addEventListeners(element, loadHandler, errorHandler);
  };

  var managedTags = ["IMG", "IFRAME", "VIDEO"];

  var onEnter = function onEnter(element, entry, instance) {
    var settings = instance._settings;
    safeCallback(settings.callback_enter, element, entry, instance);

    if (!settings.load_delay) {
      revealAndUnobserve(element, instance);
      return;
    }

    delayLoad(element, instance);
  };

  var revealAndUnobserve = function revealAndUnobserve(element, instance) {
    var observer = instance._observer;
    revealElement(element, instance);

    if (observer && instance._settings.auto_unobserve) {
      observer.unobserve(element);
    }
  };

  var onExit = function onExit(element, entry, instance) {
    var settings = instance._settings;
    safeCallback(settings.callback_exit, element, entry, instance);

    if (!settings.load_delay) {
      return;
    }

    cancelDelayLoad(element);
  };

  var cancelDelayLoad = function cancelDelayLoad(element) {
    var timeoutId = getTimeoutData(element);

    if (!timeoutId) {
      return; // do nothing if timeout doesn't exist
    }

    clearTimeout(timeoutId);
    setTimeoutData(element, null);
  };

  var delayLoad = function delayLoad(element, instance) {
    var loadDelay = instance._settings.load_delay;
    var timeoutId = getTimeoutData(element);

    if (timeoutId) {
      return; // do nothing if timeout already set
    }

    timeoutId = setTimeout(function () {
      revealAndUnobserve(element, instance);
      cancelDelayLoad(element);
    }, loadDelay);
    setTimeoutData(element, timeoutId);
  };

  var revealElement = function revealElement(element, instance, force) {
    var settings = instance._settings;

    if (!force && getWasProcessedData(element)) {
      return; // element has already been processed and force wasn't true
    }

    if (managedTags.indexOf(element.tagName) > -1) {
      addOneShotEventListeners(element, instance);
      addClass(element, settings.class_loading);
    }

    setSources(element, instance);
    setWasProcessedData(element);
    safeCallback(settings.callback_reveal, element, instance);
    safeCallback(settings.callback_set, element, instance);
  };

  var isIntersecting = function isIntersecting(entry) {
    return entry.isIntersecting || entry.intersectionRatio > 0;
  };

  var getObserverSettings = function getObserverSettings(settings) {
    return {
      root: settings.container === document ? null : settings.container,
      rootMargin: settings.thresholds || settings.threshold + "px"
    };
  };

  var setObserver = function setObserver(instance) {
    if (!supportsIntersectionObserver) {
      return false;
    }

    instance._observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        return isIntersecting(entry) ? onEnter(entry.target, entry, instance) : onExit(entry.target, entry, instance);
      });
    }, getObserverSettings(instance._settings));
    return true;
  };

  var nativeLazyTags = ["IMG", "IFRAME"];

  var shouldUseNative = function shouldUseNative(settings) {
    return settings.use_native && "loading" in HTMLImageElement.prototype;
  };

  var loadAllNative = function loadAllNative(instance) {
    instance._elements.forEach(function (element) {
      if (nativeLazyTags.indexOf(element.tagName) === -1) {
        return;
      }

      element.setAttribute("loading", "lazy");
      revealElement(element, instance);
    });
  };

  var nodeSetToArray = function nodeSetToArray(nodeSet) {
    return Array.prototype.slice.call(nodeSet);
  };

  var queryElements = function queryElements(settings) {
    return settings.container.querySelectorAll(settings.elements_selector);
  };

  var getElements = function getElements(elements, settings) {
    return purgeProcessedElements(nodeSetToArray(elements || queryElements(settings)));
  };

  var retryLazyLoad = function retryLazyLoad(instance) {
    var settings = instance._settings;
    var errorElements = settings.container.querySelectorAll("." + settings.class_error);

    _toConsumableArray(errorElements).forEach(function (element) {
      removeClass(element, settings.class_error);
      resetWasProcessedData(element);
    });

    instance.update();
  };

  var setOnlineCheck = function setOnlineCheck(instance) {
    if (!runningOnBrowser) {
      return;
    }

    window.addEventListener("online", function (event) {
      retryLazyLoad(instance);
    });
  };

  var LazyLoad = function LazyLoad(customSettings, elements) {
    this._settings = getInstanceSettings(customSettings);
    this._loadingCount = 0;
    setObserver(this);
    this.update(elements);
    setOnlineCheck(this);
  };

  LazyLoad.prototype = {
    update: function update(elements) {
      var _this = this;

      var settings = this._settings;
      this._elements = getElements(elements, settings);

      if (isBot || !this._observer) {
        this.loadAll();
        return;
      }

      if (shouldUseNative(settings)) {
        loadAllNative(this);
        this._elements = getElements(elements, settings);
      }

      this._elements.forEach(function (element) {
        _this._observer.observe(element);
      });
    },
    destroy: function destroy() {
      var _this2 = this;

      if (this._observer) {
        this._elements.forEach(function (element) {
          _this2._observer.unobserve(element);
        });

        this._observer = null;
      }

      this._elements = null;
      this._settings = null;
    },
    load: function load(element, force) {
      revealElement(element, this, force);
    },
    loadAll: function loadAll() {
      var _this3 = this;

      this._elements.forEach(function (element) {
        revealAndUnobserve(element, _this3);
      });
    }
  };
  /* Automatic instances creation if required (useful for async script loading) */

  if (runningOnBrowser) {
    autoInitialize(LazyLoad, window.lazyLoadOptions);
  }

  return LazyLoad;
});
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_toConsumableArray, "_toConsumableArray", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/proj/lazyload.js");

  __REACT_HOT_LOADER__.register(_nonIterableSpread, "_nonIterableSpread", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/proj/lazyload.js");

  __REACT_HOT_LOADER__.register(_iterableToArray, "_iterableToArray", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/proj/lazyload.js");

  __REACT_HOT_LOADER__.register(_arrayWithoutHoles, "_arrayWithoutHoles", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/proj/lazyload.js");

  __REACT_HOT_LOADER__.register(_extends, "_extends", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/proj/lazyload.js");

  __REACT_HOT_LOADER__.register(_typeof, "_typeof", "/Users/kuzquiano/Projects/CNN/Interactives/cnnix-primary-elections-quiz/src/js/proj/lazyload.js");
}();

;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

	mobileAndTabletCheck: function mobileAndTabletCheck() {
		var check = false;
		(function (a) {
			if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
		})(navigator.userAgent || navigator.vendor || window.opera);
		return check;
	},

	throttle: function throttle(fn, wait) {
		var time = Date.now();
		return function () {
			if (time + wait - Date.now() < 0) {
				fn();
				time = Date.now();
			}
		};
	},

	debounce: function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
			    args = arguments;
			var later = function later() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	},

	mapRange: function mapRange(num, in_min, in_max, out_min, out_max) {
		return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
	},

	iOSversion: function iOSversion() {
		if (/iP(hone|od|ad)/.test(navigator.platform)) {
			// supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
			var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
			return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
		}
	}

};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/interactive.eot";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/interactive.svg";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/interactive.ttf";

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/interactive.woff";

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonts/interactive.woff2";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/1.svg";

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/10.svg";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/2.svg";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/3.svg";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/4.svg";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/5.svg";

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/5things-logo-white.svg";

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/6.svg";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/7.svg";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/8.svg";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/9.svg";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/CHECK-thick-teal.svg";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/CHECK-thick-white.svg";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/X-thick-white.svg";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/_twitter.svg";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/cnn-core-logo.svg";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/cnn-logo-badge.svg";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/cnn-politics-logo.svg";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/facebook.svg";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/instagram.svg";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "media/assets/twitter.svg";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(33);
} else {
  module.exports = require('./patch.dev');
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* noop */


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = {"name":"quiz-us-primary-elections","version":"1.0.0","title":"How much do you know about the US primary elections?","headline":"How much do you know about the US primary elections?","slug":"quiz-us-primary-elections","description":"This quiz is designed to test your knowledge of primary elections in the US.","keywords":["<!-- KEYWORDS -->"],"scripts":{"start":"nodemon","start2":"NODE_ENV=development webpack-dev-server --config webpack.development.config.js --inline --hot","stage":"NODE_ENV=stage webpack -p --config webpack.development.config.js","build":"webpack -p --config webpack.production.config.js","parse":"node tasks/cnnix-paper.js && node tasks/buildHandlebars.js","release":"node ./tasks/cnnix-paper.js --build --optimize && node tasks/buildHandlebars.js","s3":"NODE_ENV=stage webpack -p --config webpack.development.config.js && node tasks/deployToS3.js"},"author":"CNN","license":"ISC","articleName":"How much do you know about the US primary elections?","cardImage":"https://media.cnn.com/api/v1/images/stellar/prod/001-ap16211088323244-jpg.jpg?c=original","dropboxPaperDocId":"DWXGKYEExil2rk0XtWCkm","filepath":"/www/cnn//interactive/2024/01/us/quiz-us-primary-elections","prodUrl":"https://www.cnn.com//interactive/2024/01/us/quiz-us-primary-elections/","cdnUrl":"https://cdn.cnn.com/cnn//interactive/2024/01/us/quiz-us-primary-elections/","cdn":"https://cdn.cnn.com/cnn//interactive/2024/01/us/quiz-us-primary-elections/","bitlyUrl":"https://cnn.it/48y3vV3","social":{"default":{"image":"https://media.cnn.com/api/v1/images/stellar/prod/001-ap16211088323244-jpg.jpg?c=original","title":"How much do you know about the US primary elections? - CNN","description":"This quiz is designed to test your knowledge of primary elections in the US."},"twitter":{"description":"This quiz is designed to test your knowledge of primary elections in the US.","account":"CNN"}},"omniture":{"section":"us","subsection":"","brandingContentPage":""},"adTargetSpec":"","repository":{"type":"git","url":"--"},"devDependencies":{"archieml":"^0.5.0","autoprefixer":"^7.1.1","babel-cli":"^6.26.0","babel-core":"^6.24.1","babel-loader":"^7.0.0","babel-plugin-react-require":"^3.0.0","babel-preset-env":"^1.6.1","babel-preset-react":"^6.24.1","babel-preset-stage-0":"^6.24.1","clean-webpack-plugin":"^0.1.16","css-loader":"^0.28.1","dotenv":"^6.2.0","dropbox":"^10.34.0","extend":"^3.0.1","extract-text-webpack-plugin":"^2.1.0","file-loader":"^0.11.1","handlebars":"^4.0.8","handlebars-loader":"^1.5.0","html-webpack-plugin":"^2.28.0","image-size":"^1.0.2","isomorphic-fetch":"^3.0.0","marked":"^3.0.0","moment":"^2.18.1","node-sass":"^4.7.2","nodemon":"^1.19.3","postcss-loader":"^2.0.5","prop-types":"^15.5.10","query-string":"^4.3.4","react":"^15.5.4","react-dom":"^15.5.4","react-hot-loader":"^3.0.0-beta.7","react-router-dom":"^4.1.1","s3-easy-deploy":"^1.1.0","sass-loader":"^6.0.5","source-map-loader":"^0.2.1","style-loader":"^0.17.0","webpack":"^2.6.0","webpack-dev-server":"^2.11.1"},"dependencies":{"axios":"^0.19.0","chalk":"^2.4.2","html-entities":"^1.2.1","htmlparser2":"^3.10.1","https":"^1.0.0","lazysizes":"^4.0.2","node-html-parser":"^6.1.5","objectFitPolyfill":"^2.1.1","rellax":"^1.6.2","request":"^2.88.0","smartypants":"^0.1.1","underscore":"^1.9.1"}}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = {"title":"How much do you know about primary elections?","headline":"How much do you know about primary elections?","description":"This quiz is designed to test your knowledge of primary elections in the US.","timestamp":{"published":"January 13, 2023","lastUpdate":null},"byline":[{"role":"By","credit":"Zachary B. Wolf, CNN"}],"header":{"headline":"How much do you know about primary elections?","dek":null,"img":"https://media.cnn.com/api/v1/images/stellar/prod/001-ap16211088323244-jpg.jpg?c=original"},"intro":{"copy":[{"value":"This quiz is designed to test your knowledge of US primary elections.","type":"text"},{"value":"<em>Keep up with the</em> <em>latest</em> <a target=\"_blank\" href=\"https://www.cnn.com/politics\"><em>politics</em></a> <a target=\"_blank\" href=\"https://www.cnn.com/politics\"><em>news</em></a> and <a target=\"_blank\" href=\"https://www.cnn.com/election/2024\"><em>2024 election</em></a> <em>outcomes</em> <em>and learn how it all connects by</em> <a target=\"_blank\" href=\"https://www.cnn.com/newsletters/what-matters\"><em>signing up for CNN’s What Matters newsletter,</em></a> <em>delivered straight to your inbox Monday through Friday.</em>","type":"text"}]},"content":[{"value":{"questions":[{"question":"What do you call the people who select the Democratic and Republican presidential candidates?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/001-ap16211088323244-jpg.jpg?c=original","options":[{"label":"Voters"},{"label":"Electors"},{"label":"Delegates","value":true,"type":"text"},{"label":"Bigwigs"}],"answer":[{"value":"Today it is primary voters who pick the presidential candidates for the Republican and Democratic parties. But each party’s nominee is technically selected by delegates sent by each state to a nominating convention. State rules vary on whether the winner of the primary gets all or only a portion of the state&#39;s delegates.","type":"text"}]},{"question":"Violence at which Democratic convention helped usher in the modern era of primaries and caucuses?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/002-gettyimages-515177534-jpg.jpg?c=original","options":[{"label":"1988 in Atlanta"},{"label":"1968 in Chicago","value":true,"type":"text"},{"label":"2000 in Los Angeles"},{"label":"1948 in Philadelphia"}],"answer":[{"value":"1968 was a pivotal year in US history. Protests sparked by the war in Vietnam converged with the convention in Chicago. The sitting Democratic president, Lyndon B. Johnson, decided not to seek reelection, and the party delegates opted for his vice president, Hubert Humphrey, rather than the anti-war candidate Sen. Eugene McCarthy of Minnesota.","type":"text"},{"value":"After violence in Chicago, party leaders made an effort to democratize the process and give more power to voters as opposed to party bigwigs.","type":"text"}]},{"question":"Which future president was the top candidate in both the Iowa caucuses and the New Hampshire primary in the year he first won the White House?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/003-ap22336100021684-jpg.jpg?c=original","options":[{"label":"Barack Obama"},{"label":"George W. Bush"},{"label":"Ronald Reagan"},{"label":"Jimmy Carter","value":true,"type":"text"}],"answer":[{"value":"Running as a Washington outsider in 1976, Jimmy Carter is the only modern president to place on top in both Iowa and New Hampshire on his way to a first term in the White House. Note: Although Carter was the top Democratic candidate in 1976 in the Iowa caucuses, he placed second to &quot;uncommitted.&quot;","type":"text"},{"value":"Obama and George W. Bush both won in Iowa but lost in New Hampshire in 2008 and 2000, respectively. George H.W. Bush lost in Iowa in 1988, when he was running as the sitting vice president, although he actually defeated Reagan in Iowa in 1980. The elder Bush did win New Hampshire in 1988. Joe Biden and Bill Clinton lost both Iowa and New Hampshire in 2020 and 1992, respectively.","type":"text"}]},{"question":"What is it called when there&#39;s no one candidate with a majority of delegates and it takes multiple rounds of voting to settle on a nominee at a party&#39;s convention?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/004-gettyimages-516002298-jpg.jpg?c=3x2","options":[{"label":"Brokered convention","value":true,"type":"text"},{"label":"Failed convention"},{"label":"Nightmare convention"},{"label":"Fractured convention"}],"answer":[{"value":"A brokered convention is one in which a candidate fails to win a majority of delegates after the first round of voting, which then leads to multiple rounds of voting to select a nominee. This is slightly different from a contested convention, which occurs when a candidate has a lead but isn’t guaranteed to win after the first ballot and another candidate tries to convince enough other delegates to switch sides before the first round of voting.","type":"text"},{"value":"The last brokered convention occurred in 1952, when Democratic Party leaders opted for Illinois Gov. Adlai Stevenson even though Sen. Estes Kefauver of Tennessee had won most of the primaries that occurred that year. Stevenson lost successive presidential elections in 1952 and 1956 to Dwight D. Eisenhower, a Republican.","type":"text"}]},{"question":"Primaries are focused on Republicans and Democrats, who field candidates on the general election ballot in all 50 states. What other political party has a presidential candidate on the ballot in every US state?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/005-gettyimages-967833574-jpg.jpg?c=original","options":[{"label":"Green Party"},{"label":"Libertarian Party"},{"label":"No Labels"},{"label":"None of the above","value":true,"type":"text"}],"answer":[{"value":"The major parties have a monopoly on the US political conversation in part because third parties cannot maintain ballot access across the country. States have different rules for political parties to remain viable and secure access for their candidates on the general election ballot in November.","type":"text"},{"value":"The Green Party and Libertarian Party are both able to maintain access in much of the country but often struggle to keep that access from election to election. The Libertarian Party anticipates having access to ballots in all 50 states in 2024. The Libertarian and Green parties pick their presidential candidates at conventions rather than in primaries.","type":"text"},{"value":"No Labels is not technically a party but did launch an effort to seek ballot access for a potential independent candidate in 2024.","type":"text"}]},{"question":"What is Super Tuesday?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/006-gettyimages-515732996-jpg.jpg?c=original","options":[{"label":"The first Tuesday on which a primary occurs"},{"label":"The Tuesday on which the largest number of primaries occur","value":true,"type":"text"},{"label":"The Tuesday on which a candidate clinches the nomination"},{"label":"The final Tuesday on which a primary occurs"}],"answer":[{"value":"States negotiate with the parties to set primary dates. Iowa and New Hampshire try to go first. But other states see value in holding their primary elections on the same date. In 2024, Super Tuesday falls on March 5 and will feature 14 primaries and a few caucuses across the country, including in large states like California and Texas. It is the primary date with the most delegates at stake. It used to be a mostly Southern pool of states.","type":"text"}]},{"question":"Iowa and New Hampshire are holding their contests in January, but the Democratic Party will recognize the South Carolina primary as the first presidential preference contest. Why do Democrats want South Carolina to go first in 2024?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/007-gettyimages-1604327669-jpg.jpg?c=original","options":[{"label":"It was the first primary Joe Biden won in 2020"},{"label":"Iowa and New Hampshire voters are not representative of the party","value":true,"type":"text"},{"label":"They prefer the warmer weather in South Carolina in February"},{"label":"They want to appeal to Trump voters"}],"answer":[{"value":"There has been frustration, particularly among Democrats, for years about Iowa and New Hampshire being the first states to get a say in presidential primaries. Neither state is known for large urban areas and both are predominantly White. Democratic voters are concentrated in urban areas, and the party has specifically tried to appeal to a racially diverse cross section of the population.","type":"text"},{"value":"While it is true that South Carolina is the first contest Biden won during the 2020 primary season, the stated reason for letting South Carolina go first is to give a more diverse group of voters the first say in the primary.","type":"text"}]},{"question":"You must join a political party in order to take part in a presidential primary.","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/gettyimages-871709348.jpg?c=3x2","options":[{"label":"True"},{"label":"False"},{"label":"It depends","value":true,"type":"text"}],"answer":[{"value":"Primary rules vary from state to state. Some states have so-called &quot;closed primaries&quot; in which a person must be a registered party member in order to take part in the primary election. In an &quot;open primary,&quot; a voter does not need to belong to a party in order to vote in the primary election.","type":"text"},{"value":"There are variations of each type — partially closed, partially open. For contests other than president, some states have adopted &quot;nonpartisan&quot; primaries in which every candidate runs in the same primary regardless of his or her political party, and the top two finishers, regardless of their party affiliation, square off on Election Day.","type":"text"}]},{"question":"Every state has Republican and Democratic primaries for federal offices.","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/009-gettyimages-1227902406-jpg.jpg?c=original","options":[{"label":"True"},{"label":"False","value":true,"type":"text"}],"answer":[{"value":"The primary system continues to evolve. While not used at the presidential level, multiple states have turned to nonpartisan or &quot;top two&quot; primaries for Senate and House races. In this system, everyone who wants to run for office, regardless of party, takes part in a single primary. The top two vote-getters, regardless of their party affiliation, square off on Election Day. That means that two Republicans or two Democrats might be facing each other in November if they are the top two vote-getters on primary day.","type":"text"}]},{"question":"Who was the first president nominated at a party convention?","questionType":"photo-question","img":"https://media.cnn.com/api/v1/images/stellar/prod/2023-07-04t181539z-1834830876-rc2iw1aj3eki-rtrmadp-3-usa-biden.jpg?c=original","options":[{"label":"Andrew Jackson","value":true,"type":"text"},{"label":"Thomas Jefferson"},{"label":"Theodore Roosevelt"},{"label":"Abraham Lincoln"}],"answer":[{"value":"A group of Democratic delegates chose Andrew Jackson as the party&#39;s nominee for the 1832 election. Before that, it was congressional caucuses that selected presidential nominees.","type":"text"},{"value":"It was not Republicans or Democrats who held the first nominating convention, but rather the short-lived Anti-Masonic Party. Conventions for three parties competing that election cycle, the National Republicans, Democrats and Anti-Masonic Party, were all held in Baltimore. This was the precursor to today&#39;s system, where it is primary voters rather than just party officials who pick presidential candidates.","type":"text"}]}]},"type":"quiz"}],"results":{"title":"You got {$label}","shareText":"I got {$label}. Take the quiz to see how much you know about US primary elections.","copy":[{"value":"General “you are finished” text goes here, if needed.","type":"text"}],"score":[{"id":"result-0","min":"0","img":null,"label":"This just wasn&#39;t your quiz! Stick with the <a target=\"_blank\" href=\"https://www.cnn.com/newsletters/what-matters?source=nl-acq_article\">What Matters newsletter</a> to learn more about US primary elections.","copy":[]},{"id":"result-1","min":"3","img":null,"label":"Eh, you could probably do better. Stick with the <a target=\"_blank\" href=\"https://www.cnn.com/newsletters/what-matters?source=nl-acq_article\">What Matters newsletter</a> to learn more about how US primary elections work.","copy":[]},{"id":"result-2","min":"6","img":null,"label":"Not bad! Stick with the <a target=\"_blank\" href=\"https://www.cnn.com/newsletters/what-matters?source=nl-acq_article\">What Matters newsletter</a> to keep connecting the dots on US elections.","copy":[]},{"id":"result-3","min":"8","img":null,"label":"Great job! You&#39;re really on top of your politics and government news and facts. Stick with the <a target=\"_blank\" href=\"https://www.cnn.com/newsletters/what-matters?source=nl-acq_article\">What Matters newsletter</a> to keep connecting the dots on all things election 2024.","copy":[]}]},"recirculation":{"title":"More from CNN","content":[{"url":"https://www.cnn.com/interactive/2023/12/us/quiz-us-government-do-you-know/","title":"US government: How well do you know how it works? - CNN","image":"https://media.cnn.com/api/v1/images/stellar/prod/001-gettyimages-1482914922-jpg.jpg?c=original"},{"url":"https://www.cnn.com/2023/12/02/politics/iowa-caucuses-what-matters/index.html","title":"Analysis: What to know about the Iowa caucuses | CNN Politics","description":"The first test of the 2024 presidential election hits January 15, when Iowa Republicans gather to caucus in high school gyms, community buildings and churches.","image":"https://media.cnn.com/api/v1/images/stellar/prod/231201143801-iowa-caucus-trump-2016.jpg?c=16x9&q=w_800,c_fill","date":"2023-12-02T14:00:31.795Z"},{"url":"https://www.cnn.com/2023/12/15/politics/2024-election-what-matters/index.html","title":"Analysis: 2024: An election about everything | CNN Politics","description":"Elections are never about any one thing, although in hindsight they may seem that way. Any issue percolating this week could have a serious effect, in ways big or small, on the outcome of an election that will in turn affect the direction of the country for everyone.","image":"https://media.cnn.com/api/v1/images/stellar/prod/231209093951-split-donald-trump-joe-biden.jpg?c=16x9&q=w_800,c_fill","date":"2023-12-15T05:00:38.037Z"}]},"social":{"url":"cnn.it/","headline":"How much do you know about primary elections?","description":"This quiz is designed to test your knowledge of US primary elections.","image":"https://media.cnn.com/api/v1/images/stellar/prod/001-ap16211088323244-jpg.jpg?c=original","facebook":{"headline":"How much do you know about primary elections?","description":"This quiz is designed to test your knowledge of US primary elections."},"twitter":{"description":"How much do you know about the US primary elections? This quiz is designed to test your knowledge."}},"credits":{"title":"Credits","content":[{"role":"Editors","credit":"Anita Narayan and Rebecca Wright"},{"role":"Image credits","credit":"Carolyn Kaster/AP, Bettmann Archive/Getty Images, AP, Bettmann Archive/Getty Images, Mario Tama/Getty Images, John Sommers II/Getty Images, Chip Somodevilla/Getty Images, Craig F. Walker/The Boston Globe/Getty Images, Jason Redmond/AFP/Getty Images, Julia Nikhinson/Reuters"}]}}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./interactive.eot": 6,
	"./interactive.svg": 7,
	"./interactive.ttf": 8,
	"./interactive.woff": 9,
	"./interactive.woff2": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./assets/1.svg": 11,
	"./assets/10.svg": 12,
	"./assets/2.svg": 13,
	"./assets/3.svg": 14,
	"./assets/4.svg": 15,
	"./assets/5.svg": 16,
	"./assets/5things-logo-white.svg": 17,
	"./assets/6.svg": 18,
	"./assets/7.svg": 19,
	"./assets/8.svg": 20,
	"./assets/9.svg": 21,
	"./assets/CHECK-thick-teal.svg": 22,
	"./assets/CHECK-thick-white.svg": 23,
	"./assets/X-thick-white.svg": 24,
	"./assets/_twitter.svg": 25,
	"./assets/cnn-core-logo.svg": 26,
	"./assets/cnn-logo-badge.svg": 27,
	"./assets/cnn-politics-logo.svg": 28,
	"./assets/facebook.svg": 29,
	"./assets/instagram.svg": 30,
	"./assets/twitter.svg": 31
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = Waypoint;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
module.exports = __webpack_require__(0);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/quiz-us-primary-elections.js